import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IOkIconProps {
    className?: string;
}

const OkIcon = (props: IOkIconProps) => {
    const className = classNames('elc-ok-icon', props.className);
    const image = `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' preserveAspectRatio='none'%3E%3Cpath d='M26.636 280.832l51.12-51.090 102.225 102.282-51.12 51.091-102.225-102.282z' /%3E%3Cpath d='M179.996 331.976l254.25-254.25 51.12 51.12-254.25 254.25-51.12-51.12z' /%3E%3Cpath d='M180.006 434.245l-51.141-51.141 51.12-51.12 51.141 51.141-51.119 51.12z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { OkIcon };
